// Auto-generated by scripts/sync-version.js — do not edit by hand.
export const APP_VERSION = '2.0.1';
export const APP_VERSION_LABEL = 'v2.0.1';
